<template>
  <div>
    <van-nav-bar
      title="请选择要签订的合同"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-steps :active="active" active-color="#ED1B23">
      <van-step>订单确认</van-step>
      <van-step>合同签署</van-step>
      <van-step>订单支付</van-step>
      <van-step>服务生效</van-step>
    </van-steps>
    <van-address-list v-if="nextStep"
      default-tag-text="默认"
      add-button-text="确认"
      v-model="chosenAddressId"
      :list="list"
      @select="contractSelection"
      @add="contractAdd"
    />
    <iframe :src="srcUrl" v-if="!nextStep"> </iframe>
    <van-button @click="handleSubmitOrder" v-if="!nextStep" type="info" style="width: 93%; margin: 2px auto">下一步</van-button>
  </div>
</template>
<script>
import { Indicator } from "mint-ui";
import {
  AddressList,
  Toast,
  Row,
  Col,
  Icon,
  NavBar,
  ContactList,
  Cell,
  Steps,
  Step,
} from "vant";
export default {
  components: {
    [AddressList.name]: AddressList,
    [Toast.name]: Toast,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [ContactList.name]: ContactList,
    [Cell.name]: Cell,
    [Steps.name]: Steps,
    [Step.name]: Step,
  },
  data() {
    return {
      srcUrl: "",
      active: 1,
      activeFooter: 3,
      chosenAddressId: "0",
      list: [],
      orderId: "",
      enterpriseId: "",
      nextStep: true,
      order: [],
      contractData: ''
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let orderSn = this.$route.query;
      this.order = orderSn
      this.orderId = this.$route.query.orderId;
      this.enterpriseId = this.$route.query.orderInfoVo.enterpriseId;
      var count = 0;
      var dat;
      this.$axios
        .get("/memberBusiness/fdd/contractTemplateList")
        .then((data) => {
          var dat = [];
          this.list = data.data;
          this.list.forEach(function (e) {
            dat.push({
              id: e.id,
              name: e.htName,
              tel: "(" + e.htContent + ")",
              contractAddress: e.contractAddress,
            });
            if (e.isDefault === "1") {
              count = e.id;
            }
          });
          this.list = dat;

          this.chosenAddressId = count;
        });
    },
    contractSelection(item, index){
      this.contractData = item
    },
    contractAdd() {
       Indicator.open({
        text: "合同生成中...",
        spinnerType: "fading-circle"
      });
       setTimeout(() => {
        Indicator.close();
      }, 60000);
      if(this.contractData===''||this.contractData===null){
        Toast('请选择要签订的合同')
      }
      this.$axios
        .post("/memberBusiness/order/updateContractNo", {
          contractAddress: this.contractData.contractAddress,
          fddContractId: this.orderId,
          htName: this.contractData.name,
          id: this.enterpriseId,
        })
        .then((data) => {
          if (data.code === 200) {
            this.nextStep = !this.nextStep
            this.srcUrl = data.data2
            Indicator.close();
          } else {
            Indicator.close();
            Toast("抬头信息丢失，跳转失败");
            // this.$router.push({path: 'order', query: {status: 4}})
          }
        });
         
    },
    onEdit(item, index) {
      // this.$axios
      //   .post("/memberBusiness/fdd/updateStatus", {
      //     fddCustomerId: item.fddCustomerId,
      //     corpName: item.name,
      //   })
      //   .then((data) => {
      //   });
      // this.$router.push({
      //   name: "edit",
      //   query: { operation: "update", id: item.id },
      // });
    },
    onClickLeft() {
      this.$router.push({ path: "/user" });
    },
    handleSubmitOrder(){
      Indicator.open({
        text: "提交合同中...",
        spinnerType: "fading-circle"
      });
      setTimeout(() => {
        Indicator.close();
      }, 60000);
      this.$axios
        .post("/memberBusiness/fdd/listContractResults", this.order.orderInfoVo)
        .then((res) => {

          if (res.code == 200) {
            this.$router.push({
              path: '/payment/',
              query: { totalPriceCount: this.order.totalPriceCount, orderId: this.order.orderId,paymentMode:this.order.paymentMode,isContract: this.order.isContract },
            });
             Indicator.close();
          }else{
            Indicator.close();
               Toast(res.message);
          }
                
          //     }
          })
          .catch(err => {
            //reject(false);
             //that.showLoad = false;
              Indicator.close();
          });
    }
  },
};
</script>

<style lang="less">
iframe {
  width: 100%;
  height: calc(100vh - 200px);
}
.button-group {
  margin: 15px;
  .van-button {
    margin-top: 10px;
  }
}
.user {
  &-poster {
    width: 100%;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}
</style>
